import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloCheckIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path
      d='M2.5 10L8.125 15.625L17.5 5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </EloBaseIcon>
)
